import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import Loginpage from './pages/Loginpage';
import Signuppage from './pages/Signuppage';
import About from './components/About';
import Tour from './components/Tour';
import Car from './components/Car';
import Contact from './components/Contact';
import Profile from './components/ProfileDashboard';
import CarDetailsPage from './pages/CarDetailsPage';
import Bookingpage from './pages/Bookingpage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div className="App">
      {/* Navbar should be outside Routes to always be present */}
      <Routes>
        {/* Pages without Navbar and Footer */}
        <Route path="/login" element={<Loginpage />} />
        <Route path="/signup" element={<Signuppage />} />

        {/* Pages with Navbar and Footer */}
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/tour" element={<Tour />} />
                <Route path="/car" element={<Car />} />
                <Route path="/carDetails/:carname/:carID" element={<CarDetailsPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/profile" element={<Profile />} />
                <Route
                  path="/booking"
                  element={
                    <ProtectedRoute>
                      <Bookingpage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
              <Footer />
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
